export { default } from "./FormativeBanner";
